import React from "react";
import { useNavigate } from "react-router-dom";

import { useOrgModParams } from "src/features/orgmod";

export function useGoToPatient(): (user: { id: string }) => void {
	const navigate = useNavigate();
	const { org, mod } = useOrgModParams();
	return React.useCallback(
		({ id }: { id: string }) => {
			navigate(`/${org}/${mod}/patients/${id}/dashboard`);
		},
		[navigate, org, mod]
	);
}
